import { TApiTaskType } from "@propely/propely-typings";
import { z } from "zod";

export const TApiGetTaskTypesResponse = z.object({
  datas: z.array(TApiTaskType),
});
export type IApiGetTaskTypesResponse = z.infer<typeof TApiGetTaskTypesResponse>;
